import React, { useState } from "react";
import { Modal, Row, Col, Form } from "react-bootstrap";

import Button from "../../../../shared/components/Buttons/Button";
import SimpleInputTextField from "../../../../shared/components/inputTextField/SimpleInputTextField";
import {
  buttonNameConstants,
  buttonTypeConstants,
} from "../../../../constants";

const ConfirmationModalWithValue = (props) => {
  const {
    size = "md",
    title = "Confirmation",
    isConfirmationModal,
    isNoButton = true,
    handleNoButtonClick,
    noButtonText = buttonNameConstants.NO,
    yesButtonText = buttonNameConstants.YES,
    handleYesButtonClick,
    toggleConfirmationModal,
    showInput = false,
    inputLabel = "",
    inputPlaceholder = "",
    isLoading = false,
  } = props;

  const [inputValue, setInputValue] = useState("");
  const [showError, setShowError] = useState(false);

  const onYesClick = () => {
    if (!inputValue.trim()) {
      setShowError(true);
      return;
    }
    handleYesButtonClick(inputValue);
    setInputValue("");
    setShowError(false);
  };

  return (
    <Modal
      size={size}
      centered
      backdrop="static"
      show={isConfirmationModal}
      onHide={toggleConfirmationModal}
      className="nested-modal-z-index"
      backdropClassName="nested-modal-z-index"
    >
      <Modal.Header className="position-relative">
        <Modal.Title className="w-100 text-center">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="m-0">
          {showInput && (
            <Col md={12} className="mb-4 d-flex align-items-start gap-2">
              {/* Label on the left */}
              <span className="stolen-card-text fs-4 input-label-normal mt-2">
                {`${inputLabel}:`}
              </span>

              {/* Input + error stacked vertically */}
              <div className="d-flex flex-column">
                <SimpleInputTextField
                  value={inputValue}
                  placeHolder="Enter nickname"
                  onChange={(e) => {
                    setInputValue(e.target.value);
                    if (showError) setShowError(false);
                  }}
                  wrapperClassName="input-30em"
                />
                {/* Always reserve space for error */}
                <div className="text-red mt-1" style={{ minHeight: "1.25em" }}>
                  {showError ? `${inputLabel} can't be empty` : ""}
                </div>
              </div>
            </Col>
          )}

          {/* 🔹 ACTION BUTTONS */}
          <Col md={12} className="d-flex gap-2">
            {isNoButton && (
              <Button
                type="button"
                label={noButtonText}
                buttonType={buttonTypeConstants.GHOST_BUTTON}
                className="w-100"
                handleClick={handleNoButtonClick}
                isDisabled={isLoading}
              />
            )}
            <Button
              type="button"
              label={yesButtonText}
              className="w-100"
              handleClick={onYesClick}
              disabled={showInput && !inputValue.trim()}
              isDisabled={isLoading}
              isLoading={isLoading}
            />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModalWithValue;
